/* eslint-disable */

$('#researchTabs li a[data-target="#center"]').click(function() {
  var $center_container = $('.ajax__pub_center');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_pub_center',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $center_container.empty();
        $(content).appendTo($center_container).fadeIn(300);

      }
    },
  });

})

$('.post-type-archive-publications #researchTabs li a[data-target="#focusarea"]').click(function() {
  var $center_container = $('.ajax__pub_focusarea');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_pub_focusarea',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $center_container.empty();
        $(content).appendTo($center_container).fadeIn(300);

      }
    },
  });

})

$('.post-type-archive-publications #researchTabs li a[data-target="#author"]').click(function() {
  var $center_container = $('.ajax__pub_author');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_pub_author',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $center_container.empty();
        $(content).appendTo($center_container).fadeIn(300);

      }
    },
  });

})

$('.post-type-archive-publications #researchTabs li a[data-target="#topic"]').click(function() {
  var $center_container = $('.ajax__pub_topic');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_pub_topic',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $center_container.empty();
        $(content).appendTo($center_container).fadeIn(300);

      }
    },
  });
})

$('.post-type-archive-publications #researchTabs li a[data-target="#year"]').click(function() {
  var $center_container = $('.ajax__pub_year');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_pub_year',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $center_container.empty();
        $(content).appendTo($center_container).fadeIn(300);

      }
    },
  });
})


// WEBPACK FOOTER //
// ./scripts/routes/publications.js